const accountConstants = {
  LIST_ACCOUNTS_REQUEST: 'LIST_ACCOUNTS_REQUEST',
  LIST_ACCOUNTS_SUCCESS: 'LIST_ACCOUNTS_SUCCESS',
  LIST_ACCOUNTS_FAILURE: 'LIST_ACCOUNTS_FAILURE',
  UPDATE_ACCOUNTS_REQUEST: 'UPDATE_ACCOUNTS_REQUEST',
  UPDATE_ACCOUNTS_SUCCESS: 'UPDATE_ACCOUNTS_SUCCESS',
  UPDATE_ACCOUNTS_FAILURE: 'UPDATE_ACCOUNTS_FAILURE',
  VALIDATE_ACCOUNT_REQUEST: 'VALIDATE_ACCOUNT_REQUEST',
  VALIDATE_ACCOUNT_SUCCESS: 'VALIDATE_ACCOUNT_SUCCESS', 
  VALIDATE_ACCOUNT_FAILURE: 'VALIDATE_ACCOUNT_FAILURE'
};

export default accountConstants;
